import { render } from "./FormNewCustomer.vue?vue&type=template&id=6edddb26"
import script from "./FormNewCustomer.vue?vue&type=script&lang=js"
export * from "./FormNewCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])